export var createNativeMediaElementAudioSourceNodeFactory = function createNativeMediaElementAudioSourceNodeFactory(createNativeAudioNode) {
  return function (nativeAudioContext, options) {
    return createNativeAudioNode(nativeAudioContext, function (ntvDCntxt) {
      return ntvDCntxt.createMediaElementSource(options.mediaElement);
    });
  };
};